module.exports = __webpack_public_path__ + "img/arrow_down_full.3df24c65.svg";